import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaTreeNode from './VaTreeNode.vue'

export default withConfigTransport(VaTreeNode as any)
